/* eslint-disable camelcase */

const initialState = {
  map: {
    viewport: {
      zoom: null,
      center: null,
      bbox: null
    },
    focusRequest: null,
    highlight: {},
    streetView: {
      visible: false
    },
    data: {},
    selection: null,
    mapTypeId: 'roadmap',
    traffic: false,
    drawing: {
      mode: '',
      area: null,
      complete: false,
      size: 0
    },
    measureTool: {
      active: false,
      length: 0
    },
    userLocation: null,
    disclaimer: true,
    requiresDevSecret: false,
    devSecret: null,
    linkedElement: {},
    linkedElementActive: false,
    searchResultItems: null,
    searchResultQuery: null,
    searchResultAutoExpandParent: null,
    error404Visible: false
  },
  ui: {
    dialog: {
      dateRangeVisible: false,
      subscribeVisible: false
    },
    detailTray: {
      collapsed: false
    },
    layerFilters: {
      visible: false,
      defaultOpen: true
    },
    mobileIdentify: {
      index: 0
    },
    mobileLinks: {
      visible: false
    },
    mobileMaxDetails: {
      visible: false
    },
    legend: {
      visible: false
    },
    mobileLayers: {
      visible: false
    },
    drawingOverlay: {
      visible: false
    },
    userLocationError: {
      visible: false
    }
  },
  filters: {
    layers: [],
    dateRanges: [],
    customDateRange: {
      start: null,
      end: null
    },
    selectedDateRange: null,
    initialUrlFilter: null
  },
  search: {
    loading: false,
    suggestions: {
      geocoder: [],
      places: []
    },
    value: null,
    showMarker: false,
    focused: false,
    selectedLocation: null,
    selectedLayerElement: null,
    showRecordSearchTray: false,
    recordSearchQuery: ''
  },
  notifications: {
    visible: false,
    step: 1,
    drawingShape: null,
    shapeError: false,
    dataTypes: [],
    frequency: 2,
    email: null,
    emailError: false,
    name: null,
    success: false,
    paused: false,
    uuid: null,
    tooltipVisible: true
  },
  site: {},
  snackbar: { message: null }
};

export default initialState;
